import * as types from './action-types.js';

export const openPopover = (name) => {
  return {
    type: types.POPOVERS_OPEN_POPOVER,
    popover: name
  };
};

export const closePopover = () => {
  return {
    type: types.POPOVERS_CLOSE_POPOVER
  };
};



// WEBPACK FOOTER //
// ./src/actions/popover-actions.js